import { render, staticRenderFns } from "./guanyu.vue?vue&type=template&id=8763677c&scoped=true"
import script from "./guanyu.vue?vue&type=script&lang=js"
export * from "./guanyu.vue?vue&type=script&lang=js"
import style0 from "./guanyu.vue?vue&type=style&index=0&id=8763677c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8763677c",
  null
  
)

export default component.exports